export default {
    name: 'locale',

    methods: {
        app: {
            transDomains: {},

            trans(
                string = '',
                args = {},
                domains = this.locale.transDomains,
                catalog = appData.trans.catalog
            ) {
                catalog = catalog || appData.trans.catalog;
                let stringWithDomain;
                let sep = appData.trans.separator;

                // A domain is specified.
                if (string.indexOf(sep) !== -1) {
                    if (string[0] === '@') {
                        let exp = string.split(sep);
                        let domainPart = exp[0].substr(1);
                        if (domains[domainPart]) {
                            stringWithDomain =
                                domains[domainPart] + sep + exp[1];
                        }
                    } else {
                        stringWithDomain = string;
                    }
                }
                // Use default domain
                else {
                    stringWithDomain = 'messages' + sep + string;
                }

                return this.string.format(
                    catalog[stringWithDomain] || string,
                    args
                );
            },

            getUserTimezone() {
                // Generate 'UTC+...' label in navbar using user's timezone
                if (appData.page.vars.user && appData.page.vars.user.timezone) {
                    return appData.page.vars.user.timezone;
                } else if (appData.page.vars.timezone) {
                    return appData.page.vars.timezone;
                } else {
                    return this.lib.moment.tz.guess();
                }
            },
        },

        page: {
            trans(string = '', args = {}) {
                return this.app.locale.trans(
                    string,
                    args,
                    this.translations.domains,
                    Object.assign(
                        {},
                        appData.trans.catalog,
                        this.translations.catalog
                    )
                );
            },
        },

        vue: {
            methods: {
                trans: function () {
                    return app.locale.trans.apply(this, arguments);
                },
            },
        },
    },
};
